import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {ReelAnimationState} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelAnimationState";
import {IReelStopSpinData} from "@nolimitcity/slot-game/bin/core/reel/reel/ReelController";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {ParsedGameData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedGameData";
import {ServerEvent} from "@nolimitcity/slot-game/bin/core/server/event/ServerEvent";
import {TractorBeamParsedGameData} from "../server/data/TractorBeamParsedGameData";
import {TractorBeamGameModuleConfig} from "../TractorBeamGameModuleConfig";

export class TractorBeamReels extends Reels {

    private _tractorData:TractorBeamParsedGameData;
    private _randomStackedOverlayReels:boolean [];
    private _randomStackedTriggered:boolean;
    private _randomStackSymbol:string | null;
    private _randomFeatureTriggered:boolean;
    private _firstAttentionPlayed:boolean = false;

    constructor() {
        super();
    }

    protected addEventListeners():void {
        super.addEventListeners();
        EventHandler.addEventListener(this, ServerEvent.GAME_DATA_PARSED, (event:GameEvent) => this.onGameDataParsed(event.params[0]));
    }

    protected onGameDataParsed(data:ParsedGameData):void {
        this._tractorData = <TractorBeamParsedGameData>data;
        this._randomStackedOverlayReels = this._tractorData.randomStackedOverlayReels;
        this._randomStackedTriggered = this._tractorData.randomStackedTriggered;
        this._randomFeatureTriggered = this._tractorData.isRandomFeature;
        this._firstAttentionPlayed = false;

        if(this._randomStackedTriggered) {
            //console.log("data parsed - stack triggered");
            const stackReelIndex = this._randomStackedOverlayReels.indexOf(true);
            const reels = data.reels;
            this._randomStackSymbol = reels[stackReelIndex][0];
        } else {
            this._randomStackSymbol = null;
        }
    }

    protected decideOrderOfStopOnRandomStack():number [] {
        const arrIndexes:number [] = [];

        if(this._randomStackedTriggered) {
            this._randomStackedOverlayReels.forEach((isStack:boolean, index:number) => {
                if(isStack) {
                    arrIndexes.push(index);
                }
            });

            this._randomStackedOverlayReels.forEach((isStack:boolean, index:number) => {
                if(!isStack) {
                    arrIndexes.push(index);
                }
            });
        }

        return (!this._randomStackedTriggered) ? [0, 1, 2, 3, 4] : arrIndexes;
        //return [0, 1, 2, 3, 4];
    }

    protected onStopSpin(stopData:{ quickStop:boolean, fastSpin:boolean }):void {
        this._quickStop = stopData.quickStop;
        this._fastSpin = stopData.fastSpin;
        const spinStopOffset:number = this.getSpinStopOffset();
        let stopDelay:number = 0;
        const reelOrder:number [] = this.decideOrderOfStopOnRandomStack();

        reelOrder.forEach((i:number, index) => {
            if(Reels._reels[i].currentState === ReelAnimationState.IDLE) {
                return;
            }
            const stopSpinData:IReelStopSpinData = {
                quickStop : this._quickStop,
                fastSpin : this._fastSpin,
                active : this._activeReels[i],
                spinStopOffset : spinStopOffset
            };
            stopDelay = Reels._reels[i].stopSpin(stopSpinData, stopDelay);
        });
    }

    protected onReelSpinStopped(reelId:number):void {
        if(this._randomStackedTriggered && this._randomStackedOverlayReels[reelId] && !this._firstAttentionPlayed && !this._quickStop) {
            TractorBeamGameModuleConfig.reelAttention.tryPlayAttentionReelZero();
            this._firstAttentionPlayed = true;
            //TractorBeamGameModuleConfig.particleController.killFadeParticles();
        }
        super.onReelSpinStopped(reelId);
    }
}
